var map = {
	"./pump-0.svg": "9501",
	"./pump-10.svg": "bd81",
	"./pump-20.svg": "e515",
	"./pump-30.svg": "6e64",
	"./pump-40.svg": "3f43",
	"./pump-50.svg": "945f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4196";